// GitStatusBar.js
// Simple Git status bar for VS Code-like IDE
import React, { useEffect, useState } from 'react';

const GitStatusBar = () => {
  const [branch, setBranch] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    // Placeholder: In real app, fetch from backend or run git commands
    setBranch('main');
    setStatus('✔ Clean');
  }, []);

  return (
    <span style={{ marginLeft: 16, color: '#6ee7b7' }}>
       {branch} — {status}
    </span>
  );
};

export default GitStatusBar;
